const getPieveActivityEventText = (event = {}) => {
  if (Array.isArray(event?.lines)) {
    const lineText = event.lines
      .map((line) => {
        return String(line?.text || '');
      })
      .join('\n');

    if (lineText.trim()) {
      return lineText;
    }
  }

  if (Array.isArray(event?.segments)) {
    return event.segments
      .map((segment) => {
        return String(segment?.text || '');
      })
      .join('\n');
  }

  return '';
};

export default getPieveActivityEventText;
